import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';
import { International, TUNNEL_STYLE, TunnelHeader } from '@/components/tunnel/TunnelCommun';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/tunnel`;
const HERO = 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1800&q=70';

export default function SolutionsPage() {
  const [data, setData] = useState({ familles: [], metiers: [] });
  const [erreur, setErreur] = useState(false);
  useEffect(() => { axios.get(`${API}/metiers`).then((r) => setData(r.data)).catch(() => setErreur(true)); }, []);

  return (
    <div className="tunnel min-h-screen" data-testid="solutions-page">
      <style>{TUNNEL_STYLE}</style>
      <section className="relative min-h-[70vh] flex items-end text-white">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0c2415] via-[#0c2415]/60 to-transparent" />
        <TunnelHeader clair />
        <div className="relative z-10 px-6 md:px-12 pb-16 max-w-4xl reveal">
          <p className="text-xs uppercase tracking-[0.25em] text-[#e8c75a] mb-4">Le logiciel agricole qui parle votre métier</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5">Vous parlez.<br />Tout le reste se fait tout seul.</h1>
          <p className="text-base md:text-lg text-white/85">Choisissez votre métier : on vous montre en 3 minutes ce que Bureau Agricole change chez vous.</p>
        </div>
      </section>
      <section className="px-6 md:px-12 py-16 space-y-12">
        {erreur && <p data-testid="solutions-erreur" className="text-[#8a3b12]">Les métiers ne se sont pas chargés. Rechargez la page dans un instant.</p>}
        {data.familles.map((fam, i) => (
          <div key={fam} className="reveal" style={{ animationDelay: `${i * 60}ms` }}>
            <h2 className="text-2xl md:text-3xl text-[#12321f] mb-4">{fam}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {data.metiers.filter((m) => m.famille === fam).map((m) => (
                <Link key={m.slug} to={`/solutions/${m.slug}`} data-testid={`solutions-metier-${m.slug}`}
                  className="group rounded-2xl bg-white p-5 ring-1 ring-black/5 transition-transform hover:-translate-y-1 hover:shadow-lg">
                  <span className="flex items-center justify-between font-bold text-[#12321f]">{m.nom}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
                  <span className="mt-2 block text-sm text-[#4b5a4f]">{(m.sous_types || []).slice(0, 4).join(' · ')}</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
      <International />
    </div>
  );
}
